import Coline from "../../assets/images/students/Reviews/ColineReview.jpg";
import Danae from "../../assets/images/students/Reviews/DanaeReview.jpg";
import Franck from "../../assets/images/students/Reviews/FrankReview.jpg";
import Andres from "../../assets/images/students/Reviews/AndresReview.jpg";
import Alban from "../../assets/images/students/Reviews/AlbanReview.jpg";
import Patricia from "../../assets/images/students/Reviews/PatriciaReview.jpg";

export const ReviewData = [
    {
        studentPic: Coline,
        picAlt: "Coline",
        quote: "Ça fait maintenant plus de 4 ans que nos routes se sont croisées et j’en suis ravie! Tania est incroyable, elle sait exactement comment s’y prendre pour transmettre sa passion, nous mettre à l’aise et nous permet de s’améliorer vocalement tout en s’amusant! Merci d’être une aussi bonne pédagogue !",
        studentName: "Coline D.",
        roleFR: "Elève Voice-up",
    },
    {
        studentPic: Danae,
        picAlt: "Danae",
        quote: "Tania est une prof absolument géniale ! N’hésitez pas une seconde ! Dès les premiers cours on commence par des « vraies » chansons, sans passer par des mois de « technique pure », et le plus beau c’est que ça marche ! (…) Je ne peux que recommander les cours de Tania et vous encourage à essayer, vous allez l’adopter 🙂 !!!",
        studentName: "Danaé F.",
        roleFR: "Elève Voice-up",
    },
    {
        studentPic: Franck,
        picAlt: "Franck",
        quote: "Vraiment trop top ! Bientôt trois ans que je fais des cours de chant avec Tania et je suis passé de chanteur médiocre sous la douche à presque rock star ! On progresse vite, ses méthodes sont géniales et c’est vraiment la meilleure prof du monde  Je recommande plus que vivement !",
        studentName: "Franck L.",
        roleFR: "Elève Voice-up",
    },
    {
        studentPic: Andres,
        picAlt: "Andres",
        quote: "Tania est une excellente pédagogue. Elle s'adapte tant aux débutants qu'aux chanteurs confirmés. La progression est assurée. Je recommande ses cours sans hésiter !",
        studentName: "Andres M.",
        roleFR: "Elève Voice-up",
    },
    {
        studentPic: Alban,
        picAlt: "Alban",
        quote: "Tania est une professeure exceptionelle! Elle est très expérimentée et permet, grâce à une approche personnalisée, de progresser rapidement dans la maîtrise des techniques vocales. C’est un réel plaisir de participer à ses cours de chant.",
        studentName: "Alban G.",
        roleFR: "Elève Voice-up",
    },
    {
        studentPic: Patricia,
        picAlt: "Patricia",
        quote: "Tania, professeure attentive, est réceptive à vos demandes. Elle vous accompagne avec bienveillance et compétence dans la découverte et l’exploration de votre voix. C’est un grand plaisir d’avancer grâce à ses précieux conseils. Je vous recommande vivement ses cours.",
        studentName: "Patricia F.",
        roleFR: "Elève Voice-up",
    },
];
